import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { MARKING_EDITOR_WEB_COMPONENT_ELEMENT, KEY_C, KEY_V } from '@/constants';
import { usePopupOpen } from '@/hooks';
import { checkCtrlPressed, checkShiftPressed, isActiveElementEditable } from '@/helpers';
import { handleFreeSpaceClick, copySectionContent, pasteSectionContent } from '@/actions';

export default props => {
  const { isCopyingAvailable, isPastingAvailable } = props;
  const dispatch = useDispatch();
  const isSomePopupOpen = usePopupOpen();

  useEffect(() => {
    if (isSomePopupOpen) {
      handleRemoveListenters();
    } else {
      document.addEventListener('mousedown', handleMouseDown);
      document.addEventListener('keydown', handleKeyDown);
    }
    return () => {
      handleRemoveListenters();
    };
  });

  const handleRemoveListenters = () => {
    document.removeEventListener('mousedown', handleMouseDown);
    document.removeEventListener('keydown', handleKeyDown);
  };

  const handleMouseDown = event => {
    if (event.target.nodeName !== MARKING_EDITOR_WEB_COMPONENT_ELEMENT.toUpperCase()) {
      dispatch(handleFreeSpaceClick());
    }
  };

  const handleKeyDown = event => {
    if (!isActiveElementEditable()) {
      const isCtrlPressed = checkCtrlPressed(event);
      const isShiftPressed = checkShiftPressed(event);
      const isCopyPressed = isCtrlPressed && event.code === KEY_C;
      const isPastePressed = isCtrlPressed && event.code === KEY_V;
      const withoutFormatting = isCtrlPressed && isShiftPressed;

      if (isCopyPressed) {
        if (isCopyingAvailable) {
          dispatch(copySectionContent());
        }
        return;
      }
      if (isPastePressed) {
        if (isPastingAvailable) {
          event.stopPropagation();
          event.preventDefault();
          dispatch(pasteSectionContent({ withoutFormatting }));
        }
        return;
      }
    }
  };
};
